export default __webpack_public_path__ + "23448b51c49a286dcf6054ac4beb8e70.jpg";